module.exports = "/virtual-football-league/img/amblems/left/Spain/Fake_RealMadrid.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/Spain/Fake_RealMadrid.png
// module id = 2047
// module chunks = 4